module.exports = __webpack_public_path__ + "static/media/happy-bear.1f42468c.gif";